export default __webpack_public_path__ + "static/media/620.1024fe8d.gif";